/**
 * Catalogue-card thumbnail candidate resolution.
 * Pure helper so fallback order can be tested without DOM event simulation.
 */

export type CardThumbnailCandidates = {
  /** First spreadsheet-owned remote image, if any. */
  spreadsheetUrl: string | null | undefined;
  /** Local image marked isPrimary, if any. */
  localPrimaryUrl: string | null | undefined;
  /** First local/OCR image in existing order, if any. */
  firstLocalUrl: string | null | undefined;
};

/**
 * Pick the first usable card thumbnail URL.
 *
 * Priority: spreadsheet → local primary → first local → null (placeholder).
 * URLs present in `failedUrls` are skipped and never retried.
 */
export function resolveCardThumbnailUrl(
  candidates: CardThumbnailCandidates,
  failedUrls: ReadonlySet<string> = new Set(),
): string | null {
  const ordered = [
    candidates.spreadsheetUrl,
    candidates.localPrimaryUrl,
    candidates.firstLocalUrl,
  ];
  const seen = new Set<string>();
  for (const raw of ordered) {
    if (raw == null || raw === '') continue;
    if (seen.has(raw)) continue;
    seen.add(raw);
    if (failedUrls.has(raw)) continue;
    return raw;
  }
  return null;
}
